// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/1.png"

function Contact() {
    
    return (
        <div className="min-h-screen max-w-2xl text-black p-4 font-serif">
        {/* Name */}
        <p className="font-bold text-3xl mb-2">
        Contact Us
        </p>

        {/* Email */}
        <p className="text-lg mb-2 mt-4">
        Dr. Navin Kumar
        </p>
        <p className="f text-lg mb-2">
        Professor & Head
        </p><p className="text-lg mb-2">
        Department of Mechanical and Biomedical Engineering
        </p><p className="text-lg mb-2">
        Office-Room No.425(3rd-Floor), Satish Dhawan Block, IIT Ropar
        </p><p className=" text-lg mb-2">
        Phone- +91-950-121-2380
        </p><p className=" text-lg mb-2">
        E-Mail- nkumar@iitrpr.ac.in
        </p>

    </div>
    );
}

export default Contact;